import { Klass, u_ } from "@pressmedia/webappbase";

/**
 * API操作用モジュールの生成
 */
function createModule() {
	if( !(this instanceof Klass("WebAppBase") ) ) {
		throw new TypeError("The caller must be instanceof WebAppBase.");
	}
	
	return Klass.new_(this.moduleKlass, {
		app: this,
		
		// エラー処理
		errorCallbacks: {
			// 認証エラー
			/**
			 * 認証エラー
			 * @param {Array} messages
			 * @param {String} methodName
			 * @param {Integer} errcode
			 * @param {String} errtype
			 * @returns
			 */
			async LOGIN(messages, methodName, errcode, errtype) {
				if( u_.isFunction(this.loginErrorCallback) ) {
					await this.loginErrorCallback.apply(this, arguments);
				}
				
				if(this.app.isReady) {
					// csvフォームを開いていた場合向けの対応
					
					// ログイン待ちの状態にしてログインフォームを表示
					this.app.popup.hideAllContents();
					this.app.setWaitingLogin();
					return this.app.showLoginForm();
				}
			}
		},
		
		/**
		 * データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
		 * @param {Integer} i
		 * @param {Object} item
		 * @param {Object} res
		 * @returns
		 */
		itemFilter(i, item, res) {
			const dk = this.getDataKey();
			let rtn = true;
			
			if(!this.app.config.account) {
				return false;
			}
			
			// for `users`
			if(dk === "users" && item.uid === this.app.config.account.uid) {
				delete item.lv;
			}
			
			if( u_.isFunction(this.app.itemFilterCallBacks.always) ) {
				rtn = this.app.itemFilterCallBacks.always.apply(this, arguments);
			}
			
			if( rtn !== false && u_.isFunction(this.app.itemFilterCallBacks[dk]) ) {
				rtn = this.app.itemFilterCallBacks[dk].apply(this, arguments);
			}
			
			return rtn;
		},
		
		// 設定情報の上書き
		configOverride: {
			fltrs: {}
		}
	});
}

export default createModule;
